import { createTheme } from '@mui/material';
import { palette } from 'assets/styles/colors';
import radius from '../radius';

const theme = createTheme({ ...radius });

const defaultBorderRadius = theme.radius.sm;
const defaultBgColor = palette.blue[50];
const defaultTextColor = palette.blue[200];

const chip = {
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: defaultBorderRadius,
        fontSize: '0.9rem',
        fontWeight: 'bold',
        lineHeight: '1.2rem',

        '&.MuiChip-colorDefault': {
          backgroundColor: defaultBgColor,
          color: defaultTextColor,

          '.MuiSvgIcon-root': {
            color: defaultTextColor,
          },
        },

        '.MuiSvgIcon-root': {
          fontSize: '1.2rem',
        },
      },
    },
  },
};

export default chip;
